import { Request } from '@/http/request'

export const apiAuthFace = (parameter: any) => {
  return Request.axiosInstance.post('/open/open-api/api-auth-face', parameter)
}